import { Routes, Route, Navigate } from 'react-router-dom';
import { Container } from '@vnetwork/ui/layout';
import { AesConsole } from './AesConsole';
import { DrmConsole } from './drm/DrmConsole';

/**
 * AES gateway (HLS AES-128 — VOD/LIVE) ops module, per provisioned service.
 *
 *   /services/aes/:serviceId         → ops console for that customer's gateway
 *   /services/aes/:serviceId/drm/*   → DRM Management (BETA) — sources, keys, rotation
 *   /services/aes                    → back to the services dashboard
 *
 * DRM is a sibling route (not nested in AesConsole) so only one console mounts at
 * a time — each owns the app's ContextualSidebar via useSetContextualNav without
 * the two fighting over it.
 */
export function AesPage() {
  return (
    <Routes>
      <Route
        path=":serviceId/drm/*"
        element={
          <Container size="xl">
            <DrmConsole />
          </Container>
        }
      />
      <Route
        path=":serviceId/*"
        element={
          <Container size="xl">
            <AesConsole />
          </Container>
        }
      />
      <Route index element={<Navigate to="/services" replace />} />
    </Routes>
  );
}

export default AesPage;
